import styled from 'styled-components';

export const PageContainer = styled.section<{isMobile: boolean}>`
  height: ${props => (props.isMobile ? 'calc(100vh - 4rem)' : '100vh')};
`;

export const openUrl = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';

  a.click();
};
